---
nb:
  admin:
    market_prices:
      empty_state: Ingen markedsprisdata for dette valget.
      errors:
        generic: Kunne ikke laste markedsprisdata.
      filters:
        date: Dato
        month: Måned
        price_area: Prisområde
        week_label_placeholder: Velg en uke
        week_start: Uke som starter
        year: År
      missing_hours:
        caption_clear: Alle {total} forventede timer er tilgjengelige
        caption_missing: "{missing} av {total} forventede timer mangler"
        range_display: "{start} – {end}"
        row_caption:
          one: "{count} manglende time"
          other: "{count} manglende timer"
        title: Manglende timer
        value_clear: Alt i orden
        value_missing:
          one: "{count} manglende time"
          other: "{count} manglende timer"
        view_day: Vis dag
      modes:
        day: Dag
        month: Måned
        week: Uke
      summary:
        coverage_caption: "{present} / {total} timer tilgjengelig"
        coverage_label: Dekning
        missing_caption_unknown: Manglende timer kunne ikke bestemmes.
        missing_label: Manglende timer
        missing_value_unknown: "—"
        price_range: Min {min} · Maks {max}
      table:
        elspot_eur: Elspot EUR
        elspot_nok: Elspot NOK
        hour: Time
        no_value: "–"
        timestamp: Tidsstempel
      timeline:
        coverage_caption: "{present} av {total} timer tilgjengelig"
        coverage_value: "{percent}% dekning"
        gaps_detected: Manglende perioder
        missing_caption:
          one: "{count} manglende time"
          other: "{count} manglende timer"
        prompt_select_day: Velg en dag fra tidslinjen for å se detaljer.
        title: Dekningsoversikt
      timezone_label: Tidssone · {timezone}
      title: Markedspriser
